/* CT product stale-cache compatibility 20260722 */
(function(){
  window.__ctProductCacheBridge = '20260722';

  function roots(){ return Array.prototype.slice.call(document.querySelectorAll('[data-ctc-booking]')); }
  function blockLegacyRescue(){
    roots().forEach(function(root){ root.dataset.ctcRescueBound = '1'; });
  }
  function cleanSupportCopy(scope){
    if(!scope || !document.createTreeWalker || typeof NodeFilter === 'undefined') return;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while(walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function(node){
      if(node.nodeValue && node.nodeValue.indexOf('24/7') !== -1){
        node.nodeValue = node.nodeValue.replace(/24\/7/g, 'planner support');
      }
    });
  }
  function ensureAnchors(root){
    if(!document.getElementById('proof')){
      var proof = document.querySelector('.route-cred-wall--proof, .route-cred-wall');
      if(proof) proof.id = 'proof';
    }
    if(!document.getElementById('plan')){
      var host = document.createElement('section');
      host.className = 'section section--cream';
      host.id = 'plan';
      host.setAttribute('data-ct-fallback-faq', '');
      host.innerHTML = '<div class="container"><div><p class="kicker">Plan Notes</p><h2>Practical setup before arrival</h2></div><div class="faq"><details open><summary>Is this a private journey?</summary><p>Yes. The itinerary is operated for your party rather than a mixed coach group. Final guide, vehicle and hotel arrangements are confirmed in your trip documents.</p></details><details><summary>Can I change the start date or travel pace?</summary><p>Choose your preferred start date in the booking panel. Our planning team confirms availability, and adjustments that change hotels, transport or inclusions may change the final quote.</p></details><details><summary>How do the deposit and full-payment options work?</summary><p>The booking panel shows the current amount for each option and carries your selected date and party size into the cart. Review the amount before checkout and see the payment terms for the balance schedule.</p></details><details><summary>What should I check before booking?</summary><p>Review the itinerary, inclusions, visa or permit requirements and activity level. Contact a trip planner before payment if you have dietary, mobility or rooming requirements.</p></details></div></div>';
      var reviews = document.querySelector('.ct-route-reviews');
      if(reviews && reviews.parentNode) reviews.parentNode.insertBefore(host, reviews);
      else if(root && root.parentNode) root.parentNode.insertBefore(host, root.nextSibling);
    }
  }
  function guardPastDates(root){
    if(!root || root.dataset.ctPastDateCompat === '1') return;
    var year = root.querySelector('[data-ctc-year]');
    var month = root.querySelector('[data-ctc-month]');
    var day = root.querySelector('[data-ctc-day]');
    if(!year || !month || !day) return;
    root.dataset.ctPastDateCompat = '1';
    function update(){
      var today = new Date();
      var selectedYear = Number(year.value || 0);
      var selectedMonth = Number(month.value || 0);
      Array.prototype.slice.call(month.options).forEach(function(option){
        if(!option.value) return;
        option.disabled = selectedYear === today.getFullYear() && Number(option.value) < (today.getMonth() + 1);
      });
      if(selectedYear === today.getFullYear() && selectedMonth && selectedMonth < (today.getMonth() + 1)){
        month.value = '';
        day.value = '';
        selectedMonth = 0;
      }
      Array.prototype.slice.call(day.options).forEach(function(option){
        if(!option.value) return;
        option.disabled = selectedYear === today.getFullYear() && selectedMonth === (today.getMonth() + 1) && Number(option.value) < today.getDate();
      });
      if(selectedYear === today.getFullYear() && selectedMonth === (today.getMonth() + 1) && Number(day.value || 0) < today.getDate()) day.value = '';
    }
    year.addEventListener('change', update);
    month.addEventListener('change', update);
    update();
  }
  function install(){
    roots().forEach(function(root){
      delete root.dataset.ctcRescueBound;
      ensureAnchors(root);
      guardPastDates(root);
      cleanSupportCopy(root);
    });
    cleanSupportCopy(document.querySelector('.route-cred-wall'));
    cleanSupportCopy(document.querySelector('footer'));
  }

  blockLegacyRescue();
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ window.setTimeout(install, 0); }, { once: true });
  else install();
})();

/* ChinaTourly Visual Interaction Layer v2
   Task: yegelite-20260523-142348-c51840cf (rework3)
   Target: backup theme 153362694312 (20260518) ONLY
   Scope: additive; skips if section already has its own observer.
   Style: editorial / restrained / desktop-first visibility. */
(function(){
  var ROOT = document;
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HAS_IO = 'IntersectionObserver' in window;

  function ready(fn){
    if (ROOT.readyState !== 'loading') fn();
    else ROOT.addEventListener('DOMContentLoaded', fn);
  }

  function observeReveal(rootSel, childSel, opts){
    if (!HAS_IO || REDUCED) return;
    var roots = ROOT.querySelectorAll(rootSel);
    if (!roots.length) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){
          var kids = e.target.querySelectorAll(childSel);
          kids.forEach(function(el, i){
            if (!el.classList.contains('ct-rv') && !el.classList.contains('ct-rv-fade')
                && !el.classList.contains('ct-rv-left') && !el.classList.contains('ct-rv-right')){
              el.classList.add(opts && opts.cls ? opts.cls : 'ct-rv');
            }
            if (!el.style.getPropertyValue('--ct-d')){
              var delay = Math.min(i, 9) * 90;
              el.style.setProperty('--ct-d', delay + 'ms');
            }
            requestAnimationFrame(function(){ el.classList.add('is-v'); });
          });
          io.unobserve(e.target);
        }
      });
    }, { threshold: (opts && opts.threshold) || 0.12, rootMargin: '0px 0px -56px 0px' });
    roots.forEach(function(r){ io.observe(r); });
  }

  ready(function(){
    /* 1. ct6 reveal parity */
    if (HAS_IO && !REDUCED) {
      var ct6Sections = ROOT.querySelectorAll('.ct6-page .ct6-section');
      ct6Sections.forEach(function(sec){
        var children = sec.querySelectorAll(
          '.ct6-kicker, .ct6-title, .ct6-lede, .ct6-copy, .ct6-photo, ' +
          '.ct6-fact, .ct6-step, .ct6-card, .ct6-panel, .ct6-wide-card, ' +
          '.ct6-feature-row, .ct6-accord details, .ct6-mini-img'
        );
        children.forEach(function(el, i){
          if (!el.classList.contains('ct-rv') && !el.classList.contains('ct-anim')){
            el.classList.add('ct-rv');
            el.style.setProperty('--ct-d', Math.min(i, 8) * 80 + 'ms');
          }
        });
      });
      if (ct6Sections.length){
        var io6 = new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if (e.isIntersecting){
              e.target.querySelectorAll('.ct-rv, .ct-anim').forEach(function(el){
                el.classList.add('is-v');
              });
              io6.unobserve(e.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -56px 0px' });
        ct6Sections.forEach(function(s){ io6.observe(s); });
      }
    }

    /* 2. ct2/ct4/ct8 generic reveal */
    observeReveal('.ct2-guide, .ct2-decisions, .ct2-rich-guide, .ct2-checklist, .ct2-faq, .ct2-related, .ct2-inquiry',
      '.ct2-kicker, .ct2-title, .ct2-lede, .ct2-guide__panel, .ct2-decisions__card, .ct2-rich-guide__item, .ct2-checklist__item, .ct2-faq details, .ct2-related__card, .ct2-inquiry__cta, h2, h3, p'
    );

    observeReveal('.ct8-page .ct8-section',
      '.ct8-kicker, .ct8-title, .ct8-lede, .ct8-deep-card, .ct8-accord details, .ct8-anchor-nav, .ct8-media, .ct8-content-row, h2, h3, p'
    );

    observeReveal('.ct11-about .ct11-section, .ct11-about .ct11-proof, .ct12-press .ct12-section, .ct12t-grid',
      '.ct11-kicker, .ct11-title, .ct11-lede, .ct11-panel, .ct11-card, .ct11-accord details, .ct12-card, .ct12t-grid > article, h2, h3, p'
    );

    /* 3. Image crop reveal opt-in */
    if (HAS_IO && !REDUCED){
      var cropEls = ROOT.querySelectorAll('[data-ct-crop="auto"]');
      if (cropEls.length){
        var ioC = new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if (e.isIntersecting){
              e.target.classList.add('is-v');
              ioC.unobserve(e.target);
            }
          });
        }, { threshold: 0.2 });
        cropEls.forEach(function(el){ ioC.observe(el); });
      }
    }

    /* 4. Soft parallax */
    if (!REDUCED){
      var pEls = ROOT.querySelectorAll('[data-ct-parallax]');
      if (pEls.length){
        var ticking = false;
        function update(){
          ticking = false;
          var wh = window.innerHeight;
          pEls.forEach(function(el){
            var rect = el.getBoundingClientRect();
            var center = rect.top + rect.height / 2;
            var rel = (center - wh / 2) / wh;
            var speed = parseFloat(el.getAttribute('data-ct-parallax-speed') || '0.18');
            var ty = Math.max(-60, Math.min(60, -rel * 100 * speed));
            el.style.setProperty('--ct-py', ty.toFixed(1) + 'px');
          });
        }
        function onScroll(){
          if (!ticking){
            window.requestAnimationFrame(update);
            ticking = true;
          }
        }
        window.addEventListener('scroll', onScroll, { passive:true });
        window.addEventListener('resize', onScroll, { passive:true });
        update();
      }
    }

    /* 5. Auto-tag heading underline */
    var headingScope = ROOT.querySelectorAll(
      '.ct2-guide h2, .ct2-decisions h2, .ct2-rich-guide h2, .ct2-checklist h2, .ct2-faq h2, .ct2-related h2,' +
      '.ct8-section > h2, .ct11-section > h2, .ct11-proof > h2, .ct12-press > h2'
    );
    headingScope.forEach(function(h){
      if (!h.querySelector('.ct-heading-underline')){
        var inner = h.innerHTML;
        h.innerHTML = '<span class="ct-heading-underline">' + inner + '</span>';
      }
    });

    /* 6. Rail keyboard support */
    var rails = ROOT.querySelectorAll('[data-ct-rail="auto"]');
    rails.forEach(function(rail){
      if (!rail.hasAttribute('tabindex')) rail.setAttribute('tabindex', '0');
      if (!rail.hasAttribute('role')) rail.setAttribute('role', 'region');
      if (!rail.hasAttribute('aria-label')){
        rail.setAttribute('aria-label', 'Horizontal scroll list. Use arrow keys to scroll.');
      }
      rail.addEventListener('keydown', function(e){
        var first = rail.querySelector(':scope > *');
        if (!first) return;
        var step = first.getBoundingClientRect().width + 18;
        if (e.key === 'ArrowRight'){ rail.scrollBy({ left: step, behavior: 'smooth' }); e.preventDefault(); }
        if (e.key === 'ArrowLeft' ){ rail.scrollBy({ left: -step, behavior: 'smooth' }); e.preventDefault(); }
      });
    });

    /* 7. FAQ details toggle hook */
    ROOT.querySelectorAll('.ct2-faq details, .ct8-accord details, .ct6-accord details, .ct11-accord details, details.ct-fa')
      .forEach(function(d){
        d.addEventListener('toggle', function(){
          if (d.open) d.classList.add('is-open');
          else d.classList.remove('is-open');
        });
      });
  });
})();

/* e82c49ce global [data-reveal] safety */
(function(){
  function show(el){
    el.style.setProperty('opacity','1','important');
    el.style.setProperty('transform','none','important');
    el.classList.add('is-in','is-v','ct-rv');
  }
  function init(){
    var els=[].slice.call(document.querySelectorAll('[data-reveal]'));
    if(!els.length) return;
    var REDUCED=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(REDUCED||!('IntersectionObserver' in window)){ els.forEach(show); return; }
    try{
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ show(e.target); io.unobserve(e.target); } });
      },{threshold:0.05, rootMargin:'0px 0px -40px 0px'});
      els.forEach(function(el){ io.observe(el); });
    }catch(err){ els.forEach(show); return; }
    /* fail-safe: content must never stay invisible (admin editor iframe / no-scroll / mis-fire) */
    setTimeout(function(){ els.forEach(show); }, 1400);
  }
  if(document.readyState!=='loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* ChinaTourly live-theme rescue layer 2026-06-09.
   Runs after Shopify parses the current cached theme HTML. Keeps fixes scoped to
   header navigation and ct-route booking modules. */
(function(){
  var FLAG = 'ctLiveRescue20260609';

  function ready(fn){
    if(document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function injectStyle(){
    if(document.getElementById(FLAG + '-style')) return;
    var css = [
      '.ct-mega-menu.active{display:block!important;pointer-events:auto!important;}',
      '@media (min-width:990px){html body #shopify-section-header.shopify-section-header-sticky,html body #shopify-section-header.shopify-section-header-sticky sticky-header,html body #shopify-section-header.shopify-section-header-sticky sticky-header#shopify-section-headers,html body #shopify-section-header.shopify-section-header-sticky sticky-header#shopify-section-headers.header-wrapper,html body #shopify-section-header.shopify-section-header-sticky sticky-header .header,html body #shopify-section-header.shopify-section-header-sticky sticky-header .header-row,html body #shopify-section-header.shopify-section-header-sticky header#header.header{background:transparent!important;background-color:transparent!important;background-image:none!important;box-shadow:none!important;border-bottom:0!important;backdrop-filter:none!important;-webkit-backdrop-filter:none!important;}}',
      '.header .ct-header-social,.header__icons .ct-header-social{display:flex!important;align-items:center!important;}',
      '.header .header__icons .header__icon--search,.header .header__icons .header__icon--account,.header .header__icons .header__icon--cart{display:inline-flex!important;align-items:center!important;justify-content:center!important;}',
      '.header .ct-nav-list{display:flex!important;align-items:center!important;justify-content:center!important;gap:clamp(22px,3vw,46px)!important;white-space:nowrap!important;}',
      '.header .ct-nav-list>li{display:flex!important;align-items:center!important;margin:0!important;}',
      '.header .ct-nav-list .dt-sc-caret{display:none!important;}',
      '.header .ct-nav-list a{display:inline-flex!important;align-items:center!important;color:var(--ct-rice,#f5f1eb)!important;text-decoration:none!important;font-size:13px!important;font-weight:650!important;letter-spacing:.04em!important;line-height:1!important;padding:12px 0!important;}',
      '.header .ct-nav-list a:hover{color:var(--ct-bronze,#b58b4d)!important;}',
      'html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-actions{display:grid!important;grid-template-columns:1fr!important;gap:12px!important;margin-top:12px!important;}',
      'html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay{position:relative!important;display:grid!important;grid-template-columns:minmax(0,1fr) 172px!important;align-items:stretch!important;gap:18px!important;width:100%!important;min-height:164px!important;padding:0!important;border-radius:8px!important;overflow:hidden!important;text-decoration:none!important;opacity:1!important;visibility:visible!important;filter:none!important;box-sizing:border-box!important;box-shadow:0 20px 42px rgba(89,62,33,.16)!important;transition:transform .2s ease,box-shadow .2s ease!important;}',
      'html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay:hover{transform:translateY(-2px)!important;box-shadow:0 26px 54px rgba(89,62,33,.22)!important;}',
      'html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay__main{display:flex!important;flex-direction:column!important;justify-content:center!important;gap:8px!important;min-width:0!important;padding:24px 0 22px 24px!important;color:inherit!important;opacity:1!important;}',
      'html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay__side{display:flex!important;flex-direction:column!important;justify-content:center!important;align-items:stretch!important;gap:12px!important;padding:50px 20px 22px 0!important;color:inherit!important;opacity:1!important;}',
      'html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay__eyebrow{display:flex!important;align-items:center!important;min-height:32px!important;font-size:11px!important;line-height:1.25!important;font-weight:900!important;letter-spacing:.13em!important;text-transform:uppercase!important;color:inherit!important;}',
      'html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay__value-row{display:flex!important;align-items:center!important;min-height:38px!important;}',
      'html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay__price{display:block!important;font-family:Georgia,"Times New Roman",serif!important;font-size:28px!important;line-height:1.05!important;font-weight:400!important;letter-spacing:0!important;color:inherit!important;}',
      'html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay__support{display:block!important;min-height:36px!important;max-width:52ch!important;font-size:12px!important;line-height:1.45!important;font-weight:700!important;color:inherit!important;opacity:.96!important;}',
      'html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay__micro{display:flex!important;align-items:center!important;justify-content:center!important;min-height:18px!important;text-align:center!important;font-size:10px!important;line-height:1.2!important;font-weight:900!important;letter-spacing:.09em!important;text-transform:uppercase!important;color:inherit!important;opacity:.94!important;white-space:nowrap!important;}',
      'html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay__cta{display:flex!important;align-items:center!important;justify-content:center!important;width:100%!important;height:54px!important;min-height:54px!important;border-radius:999px!important;font-size:10.5px!important;line-height:1!important;font-weight:900!important;letter-spacing:.11em!important;text-transform:uppercase!important;white-space:nowrap!important;}',
      'html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay--full{background:#cf812c!important;background-image:radial-gradient(circle at 90% 8%,rgba(255,253,250,.38),transparent 32%),linear-gradient(135deg,#cf812c 0%,#efc96f 100%)!important;color:#fffdf7!important;border:1px solid #f1d48a!important;}',
      'html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay--full .ctc-pay__badge,html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay--full .ctc-pay__cta{background:#fffdf7!important;color:#9a5a1e!important;border:1px solid #fffdf7!important;}',
      'html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay--deposit{background:#40564b!important;background-image:radial-gradient(circle at 92% 10%,rgba(255,253,250,.24),transparent 32%),linear-gradient(135deg,#35483f 0%,#53685b 58%,#a47a3d 100%)!important;color:#fffdf7!important;border:1px solid #d8bb78!important;}',
      'html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay--deposit .ctc-pay__badge,html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay--deposit .ctc-pay__cta{background:#fffdf7!important;color:#42594d!important;border:1px solid #fffdf7!important;}',
      'html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay__badge{position:absolute!important;top:12px!important;right:14px!important;z-index:3!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;min-height:24px!important;padding:5px 11px!important;border-radius:999px!important;font-size:9px!important;line-height:1!important;letter-spacing:.11em!important;text-transform:uppercase!important;font-weight:900!important;}',
      'html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-payment-icons svg{background:#fff!important;border:1px solid rgba(31,24,17,.08)!important;border-radius:3px!important;filter:saturate(.92) contrast(.98)!important;}',
      '@media(max-width:680px){html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay{grid-template-columns:1fr!important;min-height:auto!important;}html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay__main{padding:20px 20px 0!important;}html body #shopify-section-template--20770722218152__route [data-ctc-booking] .ctc-pay__side{padding:10px 20px 20px!important;}}',
      '@media(max-width:767px){html body .cookie-disclaimer .cookie-content,html body .cookie-disclaimer.left .cookie-content,html body .cookie-disclaimer.right .cookie-content,html body .cookie-disclaimer.bottom .cookie-content{height:auto!important;min-height:0!important;max-height:calc(100vh - 24px)!important;padding:12px 14px!important;gap:10px!important;align-items:center!important;justify-content:flex-start!important;}html body .cookie-disclaimer .cookie-content>p{width:100%!important;margin:0!important;font-size:13px!important;line-height:1.45!important;text-align:center!important;}html body .cookie-disclaimer .cookie-content .cookie-button{width:100%!important;display:flex!important;justify-content:center!important;gap:8px!important;margin:0!important;}html body .cookie-disclaimer .cookie-content button{min-width:96px!important;min-height:38px!important;padding:8px 12px!important;line-height:1!important;}}'
    ].join('\n');
    var style = document.createElement('style');
    style.id = FLAG + '-style';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function injectJudgeMeStyle(){
    if(document.getElementById('ct-judgeme-style-20260614-js')) return;
    var css = [
      'html body #judgeme_product_reviews,html body .jdgm-review-widget{width:min(1180px,calc(100vw - 40px))!important;max-width:1180px!important;min-height:250px!important;margin:72px auto 42px!important;padding:34px!important;border:1px solid #decfb9!important;border-radius:18px!important;background:radial-gradient(circle at 86% 18%,rgba(180,135,69,.16),transparent 34%),linear-gradient(135deg,rgba(255,252,245,.96),rgba(243,234,219,.86))!important;box-shadow:0 26px 70px rgba(46,34,20,.12)!important;color:#211914!important;overflow:hidden!important;position:relative!important;}',
      'html body #judgeme_product_reviews:empty::before,html body .jdgm-review-widget:empty::before{content:"PRIVATE TRAVELLER REVIEWS";display:block!important;color:#9a7540!important;font-size:12px!important;line-height:1.2!important;font-weight:800!important;letter-spacing:.18em!important;text-transform:uppercase!important;margin:0 0 12px!important;}',
      'html body #judgeme_product_reviews:empty::after,html body .jdgm-review-widget:empty::after{content:"Verified field notes from private China travellers will appear here after completed journeys. Reviews stay tied to the exact route, planner, dates, and payment path.";display:block!important;max-width:720px!important;color:#6f6258!important;font-size:16px!important;line-height:1.75!important;}',
      'html body .jdgm-rev-widg,html body .jdgm-widget{background:transparent!important;border:0!important;color:#211914!important;}',
      'html body .jdgm-rev-widg__title{color:#211914!important;font-family:var(--font-heading-family,Georgia,serif)!important;font-size:clamp(30px,3.4vw,52px)!important;line-height:.96!important;font-weight:500!important;letter-spacing:0!important;text-transform:none!important;}',
      'html body .jdgm-star,html body .jdgm-prev-badge__stars,html body .jdgm-rev__rating{color:#b48745!important;}',
      'html body .jdgm-write-rev-link,html body .jdgm-submit-rev,html body .jdgm-btn,html body .jdgm-form__submit{min-height:46px!important;padding:14px 22px!important;border:1px solid rgba(255,255,255,.48)!important;border-radius:999px!important;background:linear-gradient(135deg,#d78734,#b56f24)!important;color:#fff!important;box-shadow:0 14px 30px rgba(181,111,36,.22)!important;font-size:12px!important;line-height:1!important;font-weight:800!important;letter-spacing:.12em!important;text-transform:uppercase!important;text-decoration:none!important;}',
      'html body .jdgm-write-rev-link:hover,html body .jdgm-submit-rev:hover,html body .jdgm-btn:hover,html body .jdgm-form__submit:hover{background:linear-gradient(135deg,#bf7429,#8d5924)!important;transform:translateY(-1px)!important;box-shadow:0 18px 38px rgba(141,89,36,.28)!important;}',
      'html body .jdgm-rev{margin:0 0 18px!important;padding:24px!important;border:1px solid rgba(180,135,69,.2)!important;border-radius:14px!important;background:rgba(255,252,245,.78)!important;box-shadow:0 16px 36px rgba(46,34,20,.07)!important;}',
      'html body .jdgm-rev__body,html body .jdgm-rev__body p,html body .jdgm-rev-widg__summary,html body .jdgm-rev-widg__summary-text{color:#42372f!important;font-size:15px!important;line-height:1.75!important;}',
      'html body .jdgm-form-wrapper{margin-top:24px!important;padding:24px!important;border:1px solid rgba(180,135,69,.24)!important;border-radius:14px!important;background:rgba(255,252,245,.72)!important;}',
      'html body .jdgm-form input,html body .jdgm-form textarea,html body .jdgm-form select{border:1px solid rgba(180,135,69,.28)!important;border-radius:10px!important;background:#fffaf1!important;color:#211914!important;min-height:44px!important;padding:12px 14px!important;}',
      '@media(max-width:749px){html body #judgeme_product_reviews,html body .jdgm-review-widget{width:calc(100vw - 28px)!important;min-height:210px!important;margin:38px auto 28px!important;padding:22px 18px!important;border-radius:16px!important;}html body #judgeme_product_reviews:empty::before,html body .jdgm-review-widget:empty::before{font-size:10px!important;letter-spacing:.14em!important;}html body #judgeme_product_reviews:empty::after,html body .jdgm-review-widget:empty::after{font-size:14px!important;line-height:1.65!important;}html body .jdgm-write-rev-link,html body .jdgm-submit-rev,html body .jdgm-btn,html body .jdgm-form__submit{width:100%!important;text-align:center!important;}}'
    ].join('\n');
    var style = document.createElement('style');
    style.id = 'ct-judgeme-style-20260614-js';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function cleanHeader(){
    var items = [
      ['Journeys', '/collections/signature-journeys', 'journeys'],
      ['Discover China', '/pages/journeys-by-destination', 'experiences'],
      ['Travel Guide', '/pages/travel-guide-hub', 'journal'],
      ['About Us', '/pages/about', 'travelguide']
    ];
    var lists = document.querySelectorAll('nav#AccessibleNav ul.ct-nav-list, .header__inline-menu ul.ct-nav-list');
    lists.forEach(function(list){
      if(list.getAttribute('data-ct-rescued') === 'true') return;
      list.innerHTML = items.map(function(item){
        return '<li class="top-level-link nav-item ct-nav-item" data-menu="' + item[2] + '"><a class="dt-sc-nav-link ct-nav-link" href="' + item[1] + '"><span>' + item[0] + '</span></a></li>';
      }).join('');
      list.setAttribute('data-ct-rescued', 'true');
    });
    document.querySelectorAll('.ct-mega-menu').forEach(function(menu){
      menu.setAttribute('aria-hidden', 'true');
    });
  }

  function bindMegaMenus(){
    var menus = document.querySelectorAll('.ct-mega-menu');
    if(!menus.length) return;

    function closeAll(except){
      menus.forEach(function(menu){
        if(menu !== except){
          menu.classList.remove('active');
          menu.setAttribute('aria-hidden', 'true');
        }
      });
    }

    document.querySelectorAll('.ct-nav-item[data-menu]').forEach(function(item){
      if(item.getAttribute('data-ct-mega-bound') === 'true') return;
      var menu = document.getElementById('ct-mega-' + item.getAttribute('data-menu'));
      var link = item.querySelector('.ct-nav-link');
      if(!menu || !link) return;
      var closeTimer;

      function openMenu(){
        window.clearTimeout(closeTimer);
        closeAll(menu);
        menu.classList.add('active');
        menu.setAttribute('aria-hidden', 'false');
      }

      function scheduleClose(){
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function(){
          if(!item.matches(':hover') && !menu.matches(':hover')){
            menu.classList.remove('active');
            menu.setAttribute('aria-hidden', 'true');
          }
        }, 140);
      }

      link.addEventListener('mouseenter', openMenu);
      item.addEventListener('mouseenter', openMenu);
      item.addEventListener('mouseleave', scheduleClose);
      menu.addEventListener('mouseenter', function(){
        window.clearTimeout(closeTimer);
        closeAll(menu);
        menu.classList.add('active');
        menu.setAttribute('aria-hidden', 'false');
      });
      menu.addEventListener('mouseleave', scheduleClose);
      item.setAttribute('data-ct-mega-bound', 'true');
    });

    if(!window.__ctMegaOutsideClickBound){
      document.addEventListener('click', function(e){
        if(!e.target.closest('.ct-nav-item') && !e.target.closest('.ct-mega-menu')) closeAll(null);
      });
      window.__ctMegaOutsideClickBound = true;
    }
  }

  function money(cents){
    return '$' + (Number(cents || 0) / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function setText(root, selector, text){
    root.querySelectorAll(selector).forEach(function(el){ el.textContent = text; });
  }

  function selectedDate(root){
    var m = root.querySelector('[data-ctc-month]');
    var d = root.querySelector('[data-ctc-day]');
    var y = root.querySelector('[data-ctc-year]');
    if(!m || !d || !y || !m.value || !d.value || !y.value) return '';
    var monthNames = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    return monthNames[Number(m.value) - 1] + ' ' + Number(d.value) + ', ' + y.value;
  }

  function defaultYear(root){
    var y = root.querySelector('[data-ctc-year]');
    if(!y) return '2027';
    if(y.value) return y.value;
    for(var i = 0; i < y.options.length; i++){
      if(y.options[i].value) return y.options[i].value;
    }
    return '2027';
  }

  function classifyDate(monthValue, dayValue){
    var m = Number(monthValue || 0);
    var day = Number(dayValue || 0);
    if(!m || !day) return null;
    if(m === 10 && day >= 1 && day <= 7) return { season:'autumn', supp:18, label:'Golden Week holiday' };
    if(m === 2 && day >= 16 && day <= 23) return { season:'winter', supp:18, label:'Spring Festival holiday' };
    if(m === 5 && day >= 1 && day <= 5) return { season:'spring', supp:18, label:'May Day holiday' };
    if(m >= 3 && m <= 5) return { season:'spring', supp:10, label:'Classic spring' };
    if(m >= 6 && m <= 8) return { season:'summer', supp:8, label:'Summer high season' };
    if(m >= 9 && m <= 11) return { season:'autumn', supp:14, label:'Autumn peak' };
    return { season:'winter', supp:0, label:'Quiet winter' };
  }

  function setExactFromChoice(root, choice){
    var month = root.querySelector('[data-ctc-month]');
    var day = root.querySelector('[data-ctc-day]');
    var year = root.querySelector('[data-ctc-year]');
    if(month && choice.getAttribute('data-month')) month.value = choice.getAttribute('data-month');
    if(day && choice.getAttribute('data-day')) day.value = choice.getAttribute('data-day');
    if(year && !year.value) year.value = defaultYear(root);
  }

  function buildHref(root, variantId, mode, state){
    if(!variantId) return '/pages/contact';
    var exact = selectedDate(root);
    var params = new URLSearchParams();
    params.set('id', variantId);
    params.set('quantity', String(state.qty));
    params.set('properties[Travel window]', state.windowText);
    params.set('properties[Exact start date]', exact || 'Planner to confirm');
    params.set('properties[Seasonal supplement]', '+' + state.supp + '%');
    params.set('properties[Payment option]', mode);
    params.set('properties[Trip value before offer]', money(state.tripValue));
    if(mode === 'Pay in full'){
      params.set('properties[Discount applied]', '20% pay-in-full');
      params.set('properties[Due today]', money(state.fullDue));
      params.set('properties[Balance after planner confirms]', '$0.00');
    } else {
      params.set('properties[Discount applied]', '10% deposit plan');
      params.set('properties[Due today]', money(state.deposit));
      params.set('properties[Balance after planner confirms]', money(state.balance));
    }
    params.set('properties[Planner confirmation required]', 'Yes');
    params.set('return_to', '/checkout');
    return '/cart/add?' + params.toString();
  }

  function bindBooking(root){
    if(!root || root.getAttribute('data-ctc-bound') === '1' || root.getAttribute('data-ct-rescue-bound') === 'true') return;
    root.setAttribute('data-ct-rescue-bound', 'true');
    root.setAttribute('data-ctc-bound', '1');
    var fullCents = Number(root.getAttribute('data-full-cents') || '0');
    var depositPct = Number(root.getAttribute('data-deposit-pct') || '20');
    var fullVariant = root.getAttribute('data-full-variant') || '';
    var depositVariant = root.getAttribute('data-deposit-variant') || '';
    var qtyInput = root.querySelector('[data-ctc-qty]');
    var state = { qty: 1, supp: 0, label: 'Selected window', season: '', windowText: 'Selected window' };

    function render(){
      if(!qtyInput) return;
      state.qty = Math.max(1, Math.min(50, parseInt(qtyInput.value || '1', 10) || 1));
      qtyInput.value = String(state.qty);
      var perTraveller = Math.round(fullCents * (1 + state.supp / 100));
      state.tripValue = Math.round(perTraveller * state.qty);
      state.fullSaving = Math.round(state.tripValue * 20 / 100);
      state.fullDue = Math.max(0, state.tripValue - state.fullSaving);
      state.depositSaving = Math.round(state.tripValue * 10 / 100);
      state.depositPlanTotal = Math.max(0, state.tripValue - state.depositSaving);
      state.deposit = Math.round(state.depositPlanTotal * depositPct / 100);
      state.balance = Math.max(0, state.depositPlanTotal - state.deposit);
      var exact = selectedDate(root);
      state.windowText = exact ? (exact + ' - ' + state.label) : state.label;

      setText(root, '[data-ctc-total]', money(state.tripValue));
      setText(root, '[data-ctc-base]', money(fullCents));
      setText(root, '[data-ctc-supp]', '+' + state.supp + '%');
      setText(root, '[data-ctc-full-saving]', money(state.fullSaving));
      setText(root, '[data-ctc-full-due]', money(state.fullDue));
      setText(root, '[data-ctc-deposit-saving]', money(state.depositSaving));
      setText(root, '[data-ctc-deposit-plan-total]', money(state.depositPlanTotal));
      setText(root, '[data-ctc-deposit]', money(state.deposit));
      setText(root, '[data-ctc-balance]', money(state.balance));
      setText(root, '[data-ctc-balance-inline]', money(state.balance));
      setText(root, '[data-ctc-full-label]', money(state.fullDue) + ' today');
      setText(root, '[data-ctc-deposit-label]', money(state.deposit) + ' today');
      setText(root, '[data-ctc-qty-copy]', String(state.qty));
      setText(root, '[data-ctc-window]', state.windowText);

      var hint = root.querySelector('[data-ctc-date-hint]');
      if(hint) hint.textContent = exact ? (state.windowText + ', +' + state.supp + '% supplement') : 'Choose a date window, or set an exact start date above.';
      var fullLink = root.querySelector('[data-ctc-pay-full]');
      var depositLink = root.querySelector('[data-ctc-pay-deposit]');
      if(fullLink) fullLink.href = buildHref(root, fullVariant, 'Pay in full', state);
      if(depositLink) depositLink.href = buildHref(root, depositVariant, depositPct + '% deposit', state);
    }

    function applyChoice(choice, syncDate){
      if(!choice) return;
      root.querySelectorAll('[data-ctc-choice]').forEach(function(btn){ btn.classList.remove('is-active'); });
      choice.classList.add('is-active');
      if(syncDate) setExactFromChoice(root, choice);
      state.season = choice.getAttribute('data-season') || '';
      state.supp = Number(choice.getAttribute('data-supp') || '0');
      state.label = choice.getAttribute('data-label') || choice.textContent.trim();
      render();
    }

    function applyExact(){
      var month = root.querySelector('[data-ctc-month]');
      var day = root.querySelector('[data-ctc-day]');
      if(!month || !day || !month.value || !day.value){ render(); return; }
      var info = classifyDate(month.value, day.value);
      if(!info){ render(); return; }
      state.season = info.season;
      state.supp = info.supp;
      state.label = info.label;
      root.querySelectorAll('[data-ctc-choice]').forEach(function(btn){
        var active = btn.getAttribute('data-season') === info.season;
        btn.classList.toggle('is-active', active);
      });
      render();
    }

    root.querySelectorAll('[data-ctc-choice]').forEach(function(choice){
      choice.addEventListener('click', function(){ applyChoice(choice, true); });
    });
    root.querySelectorAll('[data-ctc-month], [data-ctc-day], [data-ctc-year]').forEach(function(select){
      select.addEventListener('change', function(){
        applyExact();
        window.setTimeout(applyExact, 0);
        window.setTimeout(applyExact, 80);
      });
    });
    var dec = root.querySelector('[data-ctc-dec]');
    var inc = root.querySelector('[data-ctc-inc]');
    if(dec) dec.addEventListener('click', function(){ qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value || '1', 10) || 1) - 1)); render(); });
    if(inc) inc.addEventListener('click', function(){ qtyInput.value = String(Math.min(50, (parseInt(qtyInput.value || '1', 10) || 1) + 1)); render(); });
    if(qtyInput){
      qtyInput.addEventListener('input', render);
      qtyInput.addEventListener('change', render);
    }
    var active = root.querySelector('[data-ctc-choice].is-active') || root.querySelector('[data-ctc-choice]');
    applyChoice(active, true);
  }

  function boot(){
    injectStyle();
    injectJudgeMeStyle();
    cleanHeader();
    bindMegaMenus();
    /* Booking is owned by ct-route-product.liquid. */
  }

  ready(boot);
  document.addEventListener('shopify:section:load', boot);
  window.setTimeout(boot, 600);
})();

/* Cards use native Judge.me data; no embedded rating snapshots. */
